import { useCallback, useEffect, useRef, useState } from 'react';

import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

import LoadingComponent from 'components/LoadingComponent';
import { FORMAT_TIME } from 'constants/index';
import useReport from 'hooks/useReport';
import { useResize } from 'hooks/useResize';
import { calculateWidth, handleError } from 'utils/helper';

import ListTime from '../_components/ListTime';

import QuestionnaireResult from './_components/QuestionnaireResult';

/**
 * @description Get report by date
 * @returns {JSX.Element} Answer result component
 */
const AnswerResult = () => {
  const { getReportByDate } = useReport();

  const { me } = useSelector((state) => state.auth);
  const { childrenDetail } = useSelector((state) => state.children);
  const { width } = useResize();

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingPassingData, setIsLoadingPassingData] = useState(false);
  const [reportByDate, setReportByDate] = useState([]);
  const [listTime, setListTime] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const isCallingApi = useRef(false);

  const _getReportByDate = useCallback(async () => {
    if (me && childrenDetail?.id && !isCallingApi.current) {
      try {
        isCallingApi.current = true;
        const response = await getReportByDate();
        if (response) {
          setReportByDate(response);
          setListTime(response.map((item) => dayjs(item.created_at).format(FORMAT_TIME.FULL_DATE_TIME)));
        }
      } catch (error) {
        handleError(error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
    }
  }, [me, childrenDetail?.id]);

  useEffect(() => {
    _getReportByDate();
  }, [_getReportByDate]);

  const handleActiveIndex = (index) => {
    if (index === activeIndex) return;

    setActiveIndex(index);
    setIsLoadingPassingData(true);
    setTimeout(() => {
      setIsLoadingPassingData(false);
    }, 500);
  };

  if (isLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingComponent />
      </div>
    );
  }

  return (
    <div className="flex gap-4 h-full">
      {reportByDate.length === 0 ? (
        <div className="w-full h-full bg-white flex justify-center items-center">データがありません</div>
      ) : (
        <>
          <div style={calculateWidth(320, 1920, width)}>
            <ListTime activeIndex={activeIndex} setActiveIndex={handleActiveIndex} listTime={listTime} />
          </div>
          <div className="!w-full !max-w-full" style={calculateWidth(1424, 1920, width)}>
            {isLoadingPassingData ? (
              <div className="w-full h-full bg-white flex justify-center items-center">
                <LoadingComponent />
              </div>
            ) : (
              <QuestionnaireResult data={reportByDate[activeIndex]} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default AnswerResult;
